/**
 * Portal ICAVI - Serviço de domínio: Hora Extra
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const horaExtraServiceMethods = {
    async enviarHoraExtra(colaboradores) {
        try {
            const userData = localStorage.getItem('userData');
            const user = userData ? JSON.parse(userData) : {};
            const dadosComUsername = colaboradores.map(colaborador => ({
                ...colaborador,
                username: user.username,
            }));
            const response = await api.post('/api/hora-extra/salvar', dadosComUsername);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao enviar hora extra:', error);
            throw error;
        }
    },
    async salvarColaboradorHoraExtra(dados) {
        try {
            const userData = localStorage.getItem('userData');
            const user = userData ? JSON.parse(userData) : {};
            const dadosComUsername = { ...dados, username: user.username };
            const response = await api.post('/api/colaborador/hora-extra/salvar', dadosComUsername);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao salvar colaborador de hora extra:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atualizarColaboradorHoraExtra(dados) {
        try {
            const userData = localStorage.getItem('userData');
            const user = userData ? JSON.parse(userData) : {};
            const dadosComUsername = { ...dados, username: user.username };
            const response = await api.put('/api/colaborador/hora-extra/atualizar', dadosComUsername);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar colaborador de hora extra:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async excluirColaboradorHoraExtra(colaboradorId) {
        try {
            const userData = localStorage.getItem('userData');
            const user = userData ? JSON.parse(userData) : {};
            const dadosExclusao = { id: colaboradorId, username: user.username };
            const response = await api.delete('/api/colaborador/hora-extra/excluir', {
                data: dadosExclusao,
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir colaborador de hora extra:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarColaboradoresHoraExtra(dataCadastro = null, username = null) {
        try {
            let url = '/api/colaboradores/hora-extra';
            const params = new URLSearchParams();
            if (dataCadastro)
                params.append('data_cadastro', dataCadastro);
            if (username)
                params.append('username', username);
            if (params.toString()) {
                url += `?${params.toString()}`;
            }
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar colaboradores de hora extra:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
